import { Link } from "react-router-dom";
import { socialItems } from "views/landing/constants";

const SocialIcons = () => {
  return (
    <div className="flex gap-[0.571vw]  max-lg:gap-[2.13vw]">
      {socialItems.map(({ id, icon, linkUrl }) => (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to={linkUrl}
          key={id}
          className="shadow-custom flex max-lg:size-[13.33vw] size-[3.571vw] items-center justify-center rounded-full social-icon bg-[#E9EBF3] transition-colors duration-300 hover:bg-blue-200"
        >
          <img
            src={icon}
            alt="social icon"
            className="size-[1.714vw] max-lg:size-[6.4vw]"
          />
        </Link>
      ))}
    </div>
  );
};

export default SocialIcons;
